import {makeAutoObservable} from 'mobx'
import {DataObjectId, Hub} from 'yougile-model'
import {createUseStore} from '@containers/hooks'
import {Sticker} from '@extensions/sticker/sticker'
import {Task} from '@extensions/task'

interface State {
  taskId: DataObjectId
  title: string
  isDone: boolean
  isArchived: boolean
  assignedUsers: DataObjectId[] | null
}

export class TaskNameColumnStore {
  state: State

  constructor(taskId: DataObjectId) {
    this.state = {
      taskId: taskId,
      title: '',
      isDone: false,
      isArchived: false,
      assignedUsers: null
    }

    makeAutoObservable(this, {}, {autoBind: true})

    this.syncTaskData()
  }

  getCurrentTask(): Hub | undefined {
    return Task.getById(this.state.taskId)
  }

  syncTaskId(taskId: DataObjectId): void {
    this.state.taskId = taskId
  }

  syncTaskData(): void {
    const task = this.getCurrentTask()
    if (task) {
      this.state.title = task.title
      this.state.isDone = task?.data?.gtd?.state?.stage === 'done'
      this.state.isArchived = Task.isArchived(task, task.companyId)
      this.state.assignedUsers = Sticker.getUsers(task)
    }
  }
}

export const [TaskNameColumnContext, useTaskNameColumnStore] =
  createUseStore(TaskNameColumnStore)
